import React, { Component } from "react";
import { withTranslation } from "react-i18next";
import { Link, withRouter } from "react-router-dom";

import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import ProgressBar from "../progressBar/ProgressBar";

import convertToByte from "../../cores/convertToByte";
import convertUtcToLocal from "../../cores/convertUtcToLocal";

import { UPLOAD_FILE_LOCATION_TYPE } from "../../constants";

import * as uploadActions from "../../modules/upload";
import * as jobStatus from "../../cores/jobStatus";

import menuService from "@services/menuService";

class MyJobProgressCard extends Component {
    constructor(props) {
        super(props);
    }

    shouldComponentUpdate = (nextProps, prevState, snapshot) => {
        if (nextProps.job.status !== this.props.job.status) {
            return true;
        } else if (
            nextProps.job.inputFiles.filter(
                (v, i) =>
                    v &&
                    this.props.job.inputFiles[i] &&
                    v.uploadedPercentage &&
                    v.uploadedPercentage !== this.props.job.inputFiles[i].uploadedPercentage,
            )
        ) {
            return true;
        }

        return false;
    };

    onClickToggleIsFolded = (id, isFolded) => {
        const { UploadActions } = this.props;

        UploadActions.updateJobListData({ id, isFolded });
    };

    render = () => {
        const { job, isFolding = false, t, i18n, location } = this.props;
        const { spaceId, projectId } = menuService.parse(location.pathname);

        return (
            <React.Fragment>
                <div className={"date"}>
                    <dl>
                        <dt>{t(`common::label::${"Job ID"}`)}</dt>
                        <dd>
                            <Link to={menuService.paths.jobDetail(spaceId, projectId, job.id)} className="btn btn-link">
                                <span>{job.id}</span> <i className="sprite sprite-link-primary"></i>
                            </Link>
                        </dd>
                    </dl>

                    <dl>
                        <dt>{t(`common::label::${"Created"}`)}</dt>
                        <dd>{convertUtcToLocal(job.createdAt)}</dd>
                    </dl>

                    {job.completedAt && (
                        <dl>
                            <dt>{t(`common::label::${"Completed"}`)}</dt>
                            <dd>{convertUtcToLocal(job.completedAt)}</dd>
                        </dl>
                    )}
                </div>
                <div className={"list"}>
                    {isFolding && job.inputFiles.length > 1 && (
                        <button
                            type="button"
                            className="btn btn-icon-solid btn-fold"
                            onClick={(e) => {
                                if (isFolding && job.inputFiles.length > 1) {
                                    this.onClickToggleIsFolded(job.id, !job.isFolded);
                                }
                            }}
                        >
                            <i className={"sprite " + (job.isFolded ? "sprite-angle-down" : "sprite-angle-up")}></i>
                        </button>
                    )}

                    {(!isFolding || job.isFolded) && (
                        <div className="file">
                            <div className="file-info">
                                <span className="file-name">
                                    <strong className="ellipsis">
                                        {job.inputFiles && job.inputFiles.length > 0 ? job.inputFiles[0].name : ""}
                                    </strong>
                                </span>
                                {job.status !== jobStatus.values.ERROR && (
                                    <span className={"file-size"}>
                                        {job.inputFiles.length > 1
                                            ? t(`common::msg::And {{count}} Other - Total {{total}}`, {
                                                  count: job.inputFiles.length - 1,
                                                  total: convertToByte(
                                                      job.inputFiles
                                                          .map((f) => f.size)
                                                          .reduce((acc, curr) => acc + curr),
                                                  ),
                                              })
                                            : t("common::label::- Total {{totalSize}}", {
                                                  totalSize: convertToByte(job.inputFiles[0]?.size ?? 0),
                                              })}
                                    </span>
                                )}
                            </div>
                            <div className="file-status">
                                {job.status === jobStatus.values.INGESTING && (
                                    <React.Fragment>
                                        {job.inputFiles
                                            .map((f) => f.uploadedPercentage || 0)
                                            .reduce((acc, curr) => acc + curr, 0) <= 0 ? (
                                            <small>
                                                <i className={"sprite sprite-ingesting"}></i>{" "}
                                                {t(`common::label::${"Pending ingesting"}`)}...
                                            </small>
                                        ) : (
                                            <ProgressBar
                                                status={job.status}
                                                length={1}
                                                className={"bg-secondary"}
                                                progress={
                                                    job.inputFiles
                                                        .map((f) => f.uploadedPercentage || 0)
                                                        .reduce((acc, curr) => acc + curr) / job.inputFiles.length
                                                }
                                            />
                                        )}
                                    </React.Fragment>
                                )}

                                {job.status === jobStatus.values.SUBMITTED && (
                                    <React.Fragment>
                                        <small>
                                            <i className={"sprite sprite-progressing"}></i>{" "}
                                            {t(`common::label::${"Pending transcoding"}`)}...
                                        </small>
                                    </React.Fragment>
                                )}

                                {job.status === jobStatus.values.PROGRESSING && (
                                    <ProgressBar isIndeterminate={true} status={job.status} />
                                )}

                                {job.status === jobStatus.values.ERROR && (
                                    <React.Fragment>
                                        <small className={"text-error"}>
                                            {t(`common::label::${"Transcoding error"}`)}.
                                        </small>
                                    </React.Fragment>
                                )}

                                {job.status === jobStatus.values.CANCELED && (
                                    <React.Fragment>
                                        <small className={"text-cancel"}>
                                            {t(`common::label::${"Transcoding canceled"}`)}.
                                        </small>
                                    </React.Fragment>
                                )}

                                {job.status === jobStatus.values.COMPLETE && (
                                    <React.Fragment>
                                        <small className={"text-success"}>
                                            {t(`common::label::${"Transcoding complete"}`)}.
                                        </small>
                                    </React.Fragment>
                                )}
                            </div>
                        </div>
                    )}

                    {isFolding &&
                        !job.isFolded &&
                        job.inputFiles.map((file, index) => (
                            <React.Fragment key={index}>
                                <div className="file">
                                    <div className="file-info">
                                        <span className="file-name">
                                            <strong className="ellipsis">{file.name}</strong>
                                        </span>
                                        {job.status !== jobStatus.values.ERROR && (
                                            <span className={"file-size"}>{" - " + convertToByte(file.size)}</span>
                                        )}
                                    </div>
                                    <div className="file-status">
                                        {job.status === jobStatus.values.INGESTING && (
                                            <React.Fragment>
                                                {file.locationType === UPLOAD_FILE_LOCATION_TYPE.LOCAL &&
                                                file.uploadedPercentage <= 0 ? (
                                                    <small>
                                                        <i className={"sprite sprite-ingesting"}></i>{" "}
                                                        {t(`common::label::${"Pending ingesting"}`)}...
                                                    </small>
                                                ) : (
                                                    <ProgressBar
                                                        status={job.status}
                                                        length={1}
                                                        className={"bg-secondary"}
                                                        progress={
                                                            file.locationType === UPLOAD_FILE_LOCATION_TYPE.LOCAL
                                                                ? file.uploadedPercentage
                                                                : 100
                                                        }
                                                    />
                                                )}
                                            </React.Fragment>
                                        )}

                                        {job.status === jobStatus.values.SUBMITTED && (
                                            <React.Fragment>
                                                <small>
                                                    <i className={"sprite sprite-progressing"}></i>{" "}
                                                    {t(`common::label::${"Pending transcoding"}`)}...
                                                </small>
                                            </React.Fragment>
                                        )}

                                        {job.status === jobStatus.values.PROGRESSING && (
                                            <ProgressBar isIndeterminate={true} status={job.status} />
                                        )}
                                    </div>
                                </div>
                            </React.Fragment>
                        ))}
                </div>
            </React.Fragment>
        );
    };
}

let mapDispatchToProps = (dispatch) => {
    return {
        UploadActions: bindActionCreators(uploadActions, dispatch),
    };
};

MyJobProgressCard = connect(() => {
    return {};
}, mapDispatchToProps)(MyJobProgressCard);
export default withTranslation()(withRouter(MyJobProgressCard));
